
import Vue from 'vue'
import JcdcCard from '@/components/jcdc/JcdcCard.vue'
import JcdcRatings from '@/components/jcdc/JcdcRatings.vue'

interface ratingGroup {
  title?: string
  descriptions: ratingKey
}
interface ratingKey {
  text: string
  rating: number
}

export default Vue.extend({
  name: 'JcdcGradientCardGroup',
  components: { JcdcCard, JcdcRatings },
  props: {
    items: {
      type: Array as () => Array<ratingGroup>,
      required: true,
    },
    vertical: { type: Boolean, default: false },
    title: { type: String, default: '' },
    length: { type: Number, default: 5 },
  },
  computed: {
    xsScreen(): boolean {
      return this.$vuetify.breakpoint.xsOnly
    },
    smScreen(): boolean {
      return this.$vuetify.breakpoint.smOnly
    },
  },
})
